/* eslint-disable */

import React, { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import Loading from 'components/loading/Loading';
import { Row, Col, Card, Button } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import { aggiornaCurrentCliente } from 'features/global/globalSlice';

import { richiediDati, getFile } from './funzioni';
import AgingTable from './AgingTable';
import ExcelExport from 'components/export/ExcelExport';

const SVG_FELICE = (
  <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512">
    <g fill="green">
      <path d="M256,0C114.837,0,0,114.837,0,256s114.837,256,256,256s256-114.837,256-256S397.163,0,256,0z M341.333,128    C364.907,128,384,147.115,384,170.667c0,23.573-19.093,42.667-42.667,42.667c-23.573,0-42.667-19.093-42.667-42.667    C298.667,147.115,317.76,128,341.333,128z M170.667,128c23.573,0,42.667,19.115,42.667,42.667    c0,23.573-19.093,42.667-42.667,42.667c-23.573,0-42.667-19.093-42.667-42.667C128,147.115,147.093,128,170.667,128z M256,426.667    c-79.552,0-149.333-69.781-149.333-149.333c0-11.776,9.557-21.333,21.333-21.333s21.333,9.557,21.333,21.333    C149.333,333.163,200.171,384,256,384s106.667-50.837,106.667-106.667c0-11.776,9.557-21.333,21.333-21.333    s21.333,9.557,21.333,21.333C405.333,356.885,335.552,426.667,256,426.667z" />
    </g>
  </svg>
);

const SVG_MEH = (
  <svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 32 32">
    <g fill="orange">
      <g>
        <circle cx="11.167" cy="12" r="2.333" />
        <path d="M21.212,20.404c-3.373-1.092-7.051-1.092-10.424,0C10,20.66,9.567,21.506,9.823,22.294c0.254,0.788,1.1,1.222,1.889,0.965    c2.775-0.897,5.802-0.897,8.576,0c0.151,0.05,0.31,0.073,0.462,0.073c0.633,0,1.223-0.404,1.427-1.039    C22.434,21.506,22,20.661,21.212,20.404z" />
        <path d="M16,0C7.178,0,0,7.178,0,16s7.178,16,16,16c8.82,0,16-7.178,16-16S24.82,0,16,0z M16,29C8.832,29,3,23.168,3,16    S8.832,3,16,3s13,5.832,13,13S23.168,29,16,29z" />
        <circle cx="20.834" cy="12" r="2.333" />
      </g>
    </g>
  </svg>
);

const SVG_TRISTE = (
  <svg version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 558.266 558.267">
    <g fill="red">
      <g>
        <path d="M279.134,558.267c154.164,0,279.132-124.971,279.132-279.134C558.266,124.97,433.297,0,279.134,0    C124.971,0,0,124.97,0,279.133C0,433.29,124.971,558.267,279.134,558.267z M411.686,201.629c27.756,0,50.246,22.497,50.246,50.245    c0,27.749-22.498,50.246-50.246,50.246s-50.244-22.497-50.244-50.246C361.442,224.126,383.938,201.629,411.686,201.629z     M287.874,333.142c53.158,0,112.602,42.92,112.602,100.362c0,16.897-13.697,30.6-30.6,30.6c-16.904,0-30.6-13.702-30.6-30.6    c0-18.666-26.904-39.162-51.402-39.162H270.4c-24.504,0-51.402,20.496-51.402,39.162c0,16.897-13.696,30.6-30.6,30.6    c-16.903,0-30.6-13.702-30.6-30.6c0-57.442,59.45-100.362,112.602-100.362H287.874z M146.581,201.629    c27.748,0,50.245,22.497,50.245,50.245c0,27.749-22.497,50.246-50.245,50.246c-27.754,0-50.245-22.497-50.245-50.246    C96.335,224.126,118.833,201.629,146.581,201.629z" />
      </g>
    </g>
  </svg>
);

const Scadenze = (props) => {
  const { caricamentoInCorso, scadenze, clienti } = useSelector((s) => s.scadenze98);
  const { currentCliente } = useSelector((s) => s.global);

  const dispatch = useDispatch();

  useEffect(() => {
    richiediDati();
  }, []);

  if (caricamentoInCorso) return <Loading />;

  return (
    <>
      <Row>
        <Col>
          <section className="scroll-section">
            <h1>Deadlines</h1>
          </section>

          <section className='scroll-section'>
            <select
              className="form-select my-3"
              value={currentCliente}
              onChange={(e) => {
                dispatch(aggiornaCurrentCliente(e.target.value));
              }}
            >
              {clienti.map((cliente, _) => {
                return (
                  <option value={cliente} key={cliente}>
                    {cliente}
                  </option>
                );
              })}
            </select>
          </section>

          <section className="scroll-section">
            <Card>
              <Card.Header className="d-flex justify-content-between w-100">
                <Card.Title>Deadlines </Card.Title>
                <ExcelExport idTabella="tabella-scadenze" />
              </Card.Header>
              <Card.Body>
                <BootstrapTable
                  id="tabella-scadenze"
                  striped
                  bootstrap4
                  condensed
                  wrapperClasses="table-responsive"
                  keyField="Id"
                  data={scadenze.filter((o) => o?.Cliente?.trim() === currentCliente)}
                  columns={[
                    {
                      dataField: 'Anno',
                      text: 'Year',
                    },
                    {
                      dataField: 'NumFattura',
                      text: 'Invoice',
                    },
                    {
                      dataField: 'Valore',
                      text: 'Price',
                      formatter: (cell, row) => {
                        return `${row.Valuta} ${cell.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
                      },
                    },
                    {
                      dataField: 'Scadenza',
                      text: 'Deadline',
                      formatter: (cell, row) => {
                        const ritardo = parseFloat(row.GGRitardo, 10);
                        const data = new Date(cell).toDateString();
                        if (ritardo < -15) {
                          return data;
                        }

                        if (ritardo > -15 && ritardo < 0) {
                          return (
                            <div className="m-0 d-inline-block px-2 chip" style={{ background: 'orange' }}>
                              <p className="m-0 text-black text text-center">{data}</p>
                            </div>
                          );
                        }

                        return (
                          <div className="m-0 d-inline-block px-2 chip bg-danger">
                            <p className="m-0 text text-center">{data}</p>
                          </div>
                        );
                      },
                    },

                    {
                      dataField: 'GGRitardo',
                      align: 'center',
                      text: 'Delay',
                      formatter: (cell, row) => {
                        if (cell < -15) {
                          return (
                            <div className="d-flex justify-content-center align-items-center">
                              {cell} days <div style={{ width: 20, height: 20, marginLeft: 20 }}>{SVG_FELICE}</div>
                            </div>
                          );
                        }

                        if (cell > -15 && cell < 0) {
                          return (
                            <div className="d-flex justify-content-center align-items-center">
                              {cell} days <div style={{ width: 20, height: 20, marginLeft: 20 }}>{SVG_MEH}</div>
                            </div>
                          );
                        }

                        return (
                          <div className="d-flex justify-content-center align-items-center">
                            {cell} days <div style={{ width: 20, height: 20, marginLeft: 20 }}>{SVG_TRISTE}</div>
                          </div>
                        );
                      },
                    },
                    {
                      dataField: 'Modalita',
                      text: 'Payment method',
                    },
                    {
                      dataField: '',
                      text: 'Invoice',
                      formatter: (_, row) => {
                        return (
                          <Button type="button" onClick={() => getFile(row.NumFattura, row.Anno)}>
                            Print Invoice
                          </Button>
                        );
                      },
                    },
                  ]}
                />
              </Card.Body>
            </Card>
          </section>

          <section className="scroll-section my-3">
            <Card>
              <Card.Header className="d-flex justify-content-between w-100">
                <Card.Title>Aging</Card.Title>
                <ExcelExport idTabella="tabella-aging" />
              </Card.Header>

              <Card.Body>
                <AgingTable cliente={currentCliente} />
              </Card.Body>
            </Card>
          </section>
        </Col>
      </Row>
    </>
  );
};

export default Scadenze;
